import { getAdminUsers } from "@/services/role-access.service";
import { useQuery } from "@tanstack/react-query";

export const useAdminUsers = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "admin-users",
    params.page,
    params.size,
    params.search,
    params.roleName,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getAdminUsers(params),
    enabled,
    ...options,
  });
};
